import { combineReducers } from 'redux';
import { combineActions, handleActions } from 'redux-actions';
import * as actionTypes from './constants';

export const types = handleActions(
  {
    [actionTypes.INITIALIZE_ORDER_SUCCESS]: (state, action) => action.payload.types,
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.INITIALIZE_ORDER,
      actionTypes.INITIALIZE_ORDER_FAILURE,
    )]: () => [],
  },
  [],
);

export const indicatorTypes = handleActions(
  {
    [actionTypes.INITIALIZE_ORDER_SUCCESS]: (state, action) => action.payload.indicatorTypes,
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.INITIALIZE_ORDER,
      actionTypes.INITIALIZE_ORDER_FAILURE,
    )]: () => [],
  },
  [],
);

export const isFiscalCodeServiceCenter = handleActions(
  {
    [actionTypes.INITIALIZE_ORDER_SUCCESS]: (state, action) =>
      action.payload.isFiscalCodeServiceCenter,
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.INITIALIZE_ORDER,
      actionTypes.INITIALIZE_ORDER_FAILURE,
    )]: () => false,
  },
  false,
);

export const navContext = handleActions(
  {
    [actionTypes.INITIALIZE_ORDER_SUCCESS]: (state, action) => action.payload.context,
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.INITIALIZE_ORDER,
      actionTypes.INITIALIZE_ORDER_FAILURE,
    )]: () => [],
  },
  [],
);

export const scheduledItems = handleActions(
  {
    [actionTypes.INITIALIZE_ORDER_SUCCESS]: (state, action) => action.payload.scheduled,
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.INITIALIZE_ORDER,
      actionTypes.INITIALIZE_ORDER_FAILURE,
    )]: () => [],
  },
  [],
);

export const serviceTypes = handleActions(
  {
    [actionTypes.INITIALIZE_ORDER_SUCCESS]: (state, action) => action.payload.serviceTypes,
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.INITIALIZE_ORDER,
      actionTypes.INITIALIZE_ORDER_FAILURE,
    )]: () => [],
  },
  [],
);

export const businessSubTypes = handleActions(
  {
    [actionTypes.INITIALIZE_ORDER_SUCCESS]: (state, action) => action.payload.businessSubTypes,
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.INITIALIZE_ORDER,
      actionTypes.INITIALIZE_ORDER_FAILURE,
    )]: () => ({}),
  },
  {},
);

export const wizardType = handleActions(
  {
    [actionTypes.INITIALIZE_ORDER_SUCCESS]: (state, action) => action.payload.wizardType,
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.INITIALIZE_ORDER,
      actionTypes.INITIALIZE_ORDER_FAILURE,
    )]: () => ({}),
  },
  {},
);

export const isLoadingOrder = handleActions(
  {
    [actionTypes.INITIALIZE_ORDER]: () => true,
    [combineActions(
      actionTypes.INITIALIZE_ORDER_SUCCESS,
      actionTypes.INITIALIZE_ORDER_FAILURE,
    )]: () => false,
  },
  false,
);

export const machineIsRunning = handleActions(
  {
    [actionTypes.ANSWER]: (state, action) => action.payload,
    [combineActions('LOCATION_CHANGE', actionTypes.INITIALIZE_ORDER)]: () => '',
  },
  '',
);

export const redirectUrl = handleActions(
  {
    [actionTypes.CREATE_ORDER_SUCCESS]: (state, action) =>
      action.payload.redirectUri,
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.INITIALIZE_ORDER,
      actionTypes.CREATE_ORDER_FAILURE,
    )]: () => '',
  },
  '',
);

export const orderId = handleActions(
  {
    [actionTypes.CREATE_ORDER_SUCCESS]: (state, action) => action.payload.id,
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.INITIALIZE_ORDER,
      actionTypes.CREATE_ORDER_FAILURE,
    )]: () => '',
  },
  '',
);

export const useIndicatorWizard = handleActions(
  {
    [actionTypes.TOGGLE_INDICATOR_WIZARD]: (state, action) => action.payload,
  },
  false,
);

export const error = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.INITIALIZE_ORDER,
      actionTypes.INITIALIZE_ORDER_SUCCESS,
      actionTypes.CREATE_ORDER,
      actionTypes.CREATE_ORDER_SUCCESS,
      actionTypes.RESET_ERROR,
    )]: () => ({}),
    [combineActions(actionTypes.INITIALIZE_ORDER_FAILURE, actionTypes.CREATE_ORDER_FAILURE)]: (
      state,
      { payload },
    ) => payload.error,
  },
  {},
);

export const isSubmitting = handleActions(
  {
    [actionTypes.CREATE_ORDER]: () => true,
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.CREATE_ORDER_SUCCESS,
      actionTypes.CREATE_ORDER_FAILURE,
    )]: () => false,
  },
  false,
);

export const orderDescription = handleActions(
  {
    [actionTypes.SET_ORDER_DESCRIPTION]: (state, action) => action.payload,
    [combineActions(actionTypes.CREATE_ORDER_SUCCESS, actionTypes.CREATE_ORDER_FAILURE)]: () => '',
  },
  '',
);

export const directSelectionOnly = handleActions(
  {
    [actionTypes.INITIALIZE_ORDER_SUCCESS]: (state, action) => action.payload.directSelectionOnly,
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.INITIALIZE_ORDER,
      actionTypes.INITIALIZE_ORDER_FAILURE,
    )]: () => false,
  },
  false,
);

export default combineReducers({
  types,
  indicatorTypes,
  isLoadingOrder,
  machineIsRunning,
  navContext,
  scheduledItems,
  redirectUrl,
  orderId,
  error,
  isSubmitting,
  useIndicatorWizard,
  orderDescription,
  directSelectionOnly,
  serviceTypes,
  businessSubTypes,
  wizardType,
  isFiscalCodeServiceCenter,
});
